import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Collection from "../../Catalog/Collection";
import Sidebar from "../../Catalog/Sidebar";
import Navigation from "../../Catalog/Navigation";

export default class CatalogFull extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            currentPage: props.currentPage || 1,
            maxPage: props.maxPage || 1,
            pageSize: props.pageSize || 16,
            sortBy: props.sortBy || "",
            items: props.products || []
        };
        this.fetchItems = this.fetchItems.bind(this);
    }
    componentDidMount(){
        this.fetchItems();
    }
    componentDidUpdate(prevProps, prevState){
        if(this.state.currentPage != prevState.currentPage){
            this.fetchItems();
        }
    }
    fetchItems(){
        axios.get(`/api/products?currentPage=${this.state.currentPage}&pageSize=${this.state.pageSize}`)
            .then((result)=>{
                this.setState({
                    items: result.data.items,
                    maxPage: Math.ceil(result.data.total_count / this.state.pageSize)
                });
            }).catch((error)=>{
                console.error(error);
            })
        ;
    }
    render(){
        return(
            <div className="container">
                <div className="row">
                    <div className="col-12 col-sm-5 col-lg-3">
                        <Sidebar />
                    </div>
                    <div className="col-12 col-sm-7 col-lg-9">
                        <div className="catalog">
                            <h1 className="title">React Catalog</h1>
                            <Navigation
                                currentPage={Number(this.state.currentPage)}
                                maxPage={Number(this.state.maxPage)}
                                pageSize={Number(this.state.pageSize)}
                                goTo={(newPage)=>{
                                    this.setState({currentPage: newPage});
                                }}
                                changePageSize={(newPageSize)=>{
                                    this.setState({pageSize: newPageSize});
                                }}
                                changeSortBy={(newSortBy)=>{
                                    this.setState({sortBy: newSortBy});
                                }}
                            />
                            <Collection products={this.state.items} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CatalogFull.propTypes = {
    products: PropTypes.array,
    currentPage: PropTypes.string,
    maxPage: PropTypes.string,
    pageSize: PropTypes.string,
    sortBy: PropTypes.string
};
